import { Box, Grid } from '@material-ui/core';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { pushTo } from 'helpers/routes';
import { AssuranceIcon } from 'images';
import { get } from 'lodash';
import React from 'react';
import { BoxContainer, StyledTitle, StyledTag } from '../styles';

export interface CustomSpeedDialActionProps {
  icon: string;
  title: string;
  externalLink?: string;
  link?: string;
  label: string;
}
const CustomSpeedDialAction = ({
  icon,
  title,
  link,
  externalLink,
  label,
}: CustomSpeedDialActionProps) => {
  const Container = externalLink
    ? ({ children }: any) => (
        <StyledTag
          target="_blank"
          rel="noopener noreferrer"
          href={externalLink}
        >
          {children}
        </StyledTag>
      )
    : ({ children }: any) => <Box>{children}</Box>;
  return (
    <GaClickHOC category={EVENT_CATEGORIES.LOGIN} label={label}>
      <BoxContainer
        padding={1}
        onClick={() => {
          link && pushTo(link);
        }}
      >
        <Box marginLeft={1}>
          <Container>
            <Grid
              container
              spacing={1}
              justify="flex-start"
              alignItems="center"
              wrap="nowrap"
            >
              <Grid item>
                <img src={get(AssuranceIcon, icon)} alt={icon} />
              </Grid>
              <Grid item>
                <StyledTitle variant="h5">{title}</StyledTitle>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </BoxContainer>
    </GaClickHOC>
  );
};

export default CustomSpeedDialAction;
